<section class="pt-1 container-fluid px-xl-4 h-full-header d-flex flex-column">
	<form class="d-flex flex-wrap align-items-center justify-content-between mb-1 compact-controls">
		<div class="px-1">
			<input class="fs-sm px-1 py-0" type="search" placeholder="جستجو" name="keyword" [ngModel]="criteria.q"
				(ngModelChange)="navigate('q',$event)">
		</div>
		<ng-container *ngIf="user?.AccessRights?.includes('ManageJobs')">
			<div class="px-1">
				<select class="fs-sm p-1" [ngModel]="criteria.status" (ngModelChange)="navigate('status',+$event)"
					name="status">
					<option [ngValue]="JobStatus.All">وضعیت آگهی</option>
					<option [ngValue]="JobStatus.Pending">در انتظار تایید</option>
					<option [ngValue]="JobStatus.Started">تایید شده</option>
					<option [ngValue]="JobStatus.Rejected">مرجوع شده</option>
					<option [ngValue]="JobStatus.NotPaid">در انتظار پرداخت</option>
					<option [ngValue]="JobStatus.Paused">متوقف شده</option>
					<option [ngValue]="JobStatus.Finished">پایان یافته</option>
					<option [ngValue]="JobStatus.Archived">آرشیو شده</option>
				</select>
			</div>
			<div class="px-1">
				<select class="fs-sm p-1" [ngModel]="criteria.isPaid" (ngModelChange)="navigate('isPaid',$event)" name="isPaid">
					<option value="null" class="f-gray">وضعیت پرداخت</option>
					<option value="true">پرداخت شده</option>
					<option value="false">پرداخت نشده</option>
				</select>
			</div>
			<div class="px-1">
				<select class="fs-sm p-1" [ngModel]="criteria.sourcetype" (ngModelChange)="navigate('sourcetype',$event)"
					name="sourcetype">
					<option [ngValue]="undefined" class="f-gray">نوع منبع</option>
					<option [ngValue]="5">کارپیشه</option>
					<option [ngValue]="6">استخدام بانک‌ها</option>
					<option [ngValue]="1">وبسایت</option>
					<option [ngValue]="2">تلگرام</option>
					<option [ngValue]="3">اینستاگرام</option>
					<option [ngValue]="4">کاریابی</option>
				</select>
			</div>
			<div class="px-1">
				<select class="fs-sm p-1" [ngModel]="criteria.sort" (ngModelChange)="navigate('sort',$event)" name="sort">
					<option value="3">بروزرسانی</option>
					<option value="1">ثبت</option>
					<option value="4">انقضا</option>
					<option value="5">بودجه</option>
					<option value="6">بودجه مصرف شده</option>
					<option value="7">بودجه باقیمانده</option>
					<option value="8">نیاز به تقویت</option>
					<option value="9">عدم نیاز به تقویت</option>
					<option value="14">تگ جاب تایتل</option>
				</select>
			</div>
			<div class="mx-auto"></div>
			<div class="px-1" *ngIf="criteria.sourcetype == 5">
				<select class="fs-sm p-1" [ngModel]="criteria.package" (ngModelChange)="navigate('package',$event)"
					name="package">
					<option [ngValue]="undefined" class="f-gray">پکیج</option>
					<option [ngValue]="package.Key" class="f-gray" *ngFor="let package of packages">{{package.Title}}</option>
				</select>
			</div>
			<div class="px-1" *ngIf="criteria.sourcetype < 5">
				<input class="fs-sm px-1 py-0" type="search" placeholder="منبع" name="sourcename"
					[ngModel]="criteria.sourcename" (ngModelChange)="navigate('sourcename',$event)">
			</div>
		</ng-container>
		<div class="px-1">
			<select class="fs-sm p-1" [ngModel]="criteria.isExpired" (ngModelChange)="navigate('isExpired',$event)"
				name="isExpired">
				<option value="null" class="f-gray">وضعیت انقضا</option>
				<option value="false">منقضی نشده</option>
				<option value="true">منقضی شده</option>
			</select>
		</div>
		<div class="px-1">
			<select class="fs-sm p-1" [ngModel]="criteria.jtTag" (ngModelChange)="navigate('jtTag',$event)" name="jtTag">
				<option [ngValue]="undefined" class="f-gray">تگ جاب تایتل</option>
				<option [ngValue]="jt.Id" *ngFor="let jt of jobTitleTags">{{jt.Title}}</option>
			</select>
		</div>
		<div class="px-1 fs-sm d-flex align-items-center">
			<input type="checkbox" class="fs-sm" [ngModel]="criteria.isDeleted" (ngModelChange)="navigate('isDeleted',$event)"
				name="isDeleted">حذف شده‌ها
		</div>
		<div class="px-1 fs-sm d-flex align-items-center">
			<input type="checkbox" class="fs-sm" [ngModel]="criteria.abuse" (ngModelChange)="navigate('abuse',$event)"
				name="abuse">گزارش مشکل
		</div>
	</form>
	<div class="row flex-grow mh-100">
		<div class="col-4 px-1 h-100 overflow-y-auto jobs-list">
			<div class="py-1">
				<app-pagination class="mx-auto" [total]="total" [limit]="criteria.limit"></app-pagination>
			</div>
			<div class="relative h-min-full-header">
				<ngx-spinner name="list" [fullScreen]="false" type="timer"></ngx-spinner>
				<div class="rounded-xl border border-dark-gray my-2 p-2 shadow-kp white-bg pointer overflow-auto"
					*ngFor="let job of jobs" [class.border-2]="job.Id == selected?.Id"
					[class.shadow-kp-raised]="job.Id == selected?.Id" (click)="select(job.Id)">
					<div class="d-flex justify-content-between align-items-center fs-sm">
						<ng-container *ngTemplateOutlet="jobStatusBadge;context:{job:job}"> </ng-container>
						<div class="badge badge-pill vanguard-bg f-white" *ngIf="job.IsPaid">پیشتاز</div>
						<div class="badge badge-pill green-bg f-white" *ngIf="job.UsedForBuyResume">خرید رزومه</div>
						<ng-container *ngTemplateOutlet="jobKind;context:{job:job}"> </ng-container>
						<div *ngIf="job.Code">کد آگهی: KP{{job.Code}}</div>
					</div>
					<div>
						<h5 class="d-inline-block mx-2 mb-1">
							{{job.Title}}
							<span class="fs-sm mx-2" *ngIf="job.Company"><strong>کارفرما:</strong> {{job.Company}} </span>
							<span class="fs-sm mx-2"> {{[job.State,job.City,job.District]|join:' - '}} </span>
						</h5>
					</div>
					<div>
						<span class="light-gray-bg rounded-xl px-2 fs-sm" *ngIf="job.Vacancies > 1">
							{{job.Vacancies}} نفر
						</span>
						<div class="badge light-gray-bg  m-1" *ngFor="let skill of job.RequiredSkills"> {{skill}} </div>
						<div class="badge light-gray-bg  m-1" *ngFor="let type of job.JobTypes"> {{type}} </div>
						<div class="badge light-gray-bg  m-1" *ngIf="job.IsRemote"> دورکاری </div>
						<div class="badge light-gray-bg  m-1" *ngFor="let education of job.Educations"> {{education}} </div>
					</div>

					<div class="d-flex my-1">
						<div *ngIf="job.Image" class="ml-2">
							<img [src]="job.Image?.startsWith('http') ? job.Image : imageUrl+job.Image"
								(error)="$event.target.style.display='none'" style="max-height:80px;max-width:200px" />
						</div>
						<div class="flex-grow-1 text-justify fs-sm" [attr.dir]="job.IsLtr ? 'ltr' : undefined">
							{{job.Brief}}
						</div>
					</div>
					<div class="fs-xs d-flex justify-content-between">
						<div *ngIf="job.RegisterTime" [title]="job.RegisterTime|pdate">ثبت: {{job.RegisterTime|pdate}}</div>
						<div *ngIf="job.StartTime && job.Status==JobStatus.Started" [title]="job.StartTime|pdate">شروع:
							{{job.StartTime|pdate}}</div>
						<div *ngIf="job.UpdateTime" [title]="job.UpdateTime|pdate">ویرایش: {{job.UpdateTime|pdate}}</div>
					</div>
				</div>
			</div>
			<div class="py-1">
				<app-pagination class="mx-auto" [total]="total" [limit]="criteria.limit"></app-pagination>
			</div>
			<!-- <div class="btn-group" *ngIf="criteria.status==JobStatus.Pending && criteria.sourcetype==1">
				<button class="btn btn-green fs-sm p-1" type="button" (confirm)="setAll(JobStatus.Started)">تایید همه
					صفحه</button>
				<button class="btn btn-red fs-sm p-1" type="button" (confirm)="setAll(JobStatus.Rejected)">مرجوع همه
					صفحه</button>
			</div> -->
		</div>
		<div class="col-8 px-2 relative h-100 overflow-y-auto py-1">
			<ngx-spinner name="detail" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
			<div [ngSwitch]="selected.Status" *ngIf="selected"
				class="rounded-xl white-bg shadow-kp border border-dark-gray overflow-hidden">
				<div class="x-light-gray-bg mb-1 p-2 fs-sm">
					<div class="d-flex align-items-center justify-content-between">
						<div class="fs-lg">{{selected.Title}} <a class="f-blue fs-normal mx-2" [href]="'/job/' + selected.Id"
								target="_blank">مشاهده آگهی</a>&nbsp;<a class="green-bg f-white fs-normal mx-2 px-1 rounded-sm"
								[href]="'/karpasha/pipeline/job/' + selected.Id" target="_blank">کاریز</a></div>
						<ng-container *ngTemplateOutlet="jobStatusBadge;context:{job:selected}"> </ng-container>
					</div>
					<div class="d-flex justify-content-between">
						<div class="">ثبت: {{selected.RegisterTime|pdate}}</div>
						<div class="f-blue">بروزرسانی: {{selected.UpdateTime|pdate}}</div>
						<div class="f-green" *ngIf="selected.StartTime">شروع: {{selected.StartTime|pdate}}</div>
						<div class="f-red">انقضا: {{selected.ExpirationTime|pdate}}</div>
					</div>
					<div class="d-flex justify-content-between">
						<div *ngIf="selected.Code">کد آگهی: {{selected.Code}}</div>
						<div *ngIf="selected.SourceName">
							<ng-container *ngIf="selected.IsTelegram">تلگرام</ng-container>
							<ng-container *ngIf="selected.IsInstagram">اینستاگرام</ng-container>
							<ng-container *ngIf="!selected.IsTelegram && !selected.IsInstagram">سایت</ng-container>
							: {{selected.SourceName}}
						</div>
						<div *ngIf="selected.PackageKey">پکیج: {{selected.PackageKey}}</div>
						<div *ngIf="selected.InternalCategory"> نوع آگهی: {{selected.InternalCategory}}</div>
					</div>
					<div class="d-flex justify-content-between">
						<div *ngIf="selected.Budget" class="fs-normal border p-1 rounded-xl"
							[class.white-bg]="selected.Paid == selected.Budget" [class.yellow-bg]="selected.Paid != selected.Budget">
							بودجه {{selected.Budget|number}} تومان
							<span class="fs-sm mx-1" *ngIf="selected.Paid != selected.Budget">
								پرداخت شده: {{selected.Paid|number}}
							</span>
							<span class="fs-sm f-gray" *ngIf="selected.BoostNeeded">({{selected.BoostNeeded|number:'1.1-2'}})</span>
						</div>
						<ng-container *ngIf="selected._clicks && selected._applies">
							<div>{{(!selected._clicks[selected.Id]?0:selected._clicks[selected.Id][0]||0)|number}} بازدید</div>
							<ng-container *ngIf="!selected.IsIndexed">
								<div>{{(!selected._clicks[selected.Id]?0:selected._clicks[selected.Id][1]||0)|number}} بار دریافت
									اطلاعات تماس</div>
								<a class="f-blue pointer"
									[routerLink]="['/employer','applies',selected.Id]">{{(selected._applies[selected.Id]?.Count||0)|number}}
									رزومه</a>
							</ng-container>

						</ng-container>
						<div *ngIf="selected.UsedBudget">{{selected.UsedBudget|number}} تومان هزینه شده</div>
					</div>
					<div class="d-flex flex-wrap justify-content-between border-top fs-normal" *ngIf="selected._employer">
						<div>کارفرما: {{selected._employer.Name}}</div>
						<a class="f-blue" target="_blank" [routerLink]="['/', 'admin', 'user']"
							[queryParams]="{q: selected._employer.Username}">موبایل: {{selected._employer.Username}}</a>
						<div>شرکت: {{selected._employer.Employer?.Company}}
							<ng-container>
								(
								<a [href]="'/company/' + selected._employer.Employer?.Code"
									target="_blank">{{selected._employer.Employer?.Code}}</a>
								)
							</ng-container>
						</div>
						<div>تلفن: <span dir="ltr">{{selected._employer.Employer?.Phone}}</span></div>
						<div>ایمیل: <span dir="ltr">{{selected._employer.Email}}</span></div>
						<button class="btn btn-secondary btn-sm mr-1" (click)="changeOwnerModal.open()">تغییر کارفرما</button>

					</div>

				</div>
				<div *ngIf="selected?.IsDeleted" class="row">
					<button class="m-1 btn btn-red fs-sm p-1" type="button"
						(click)="setIsDeleted(selected,false)">بازیابی</button>
				</div>
				<div class="row" *ngIf="selected?.IsDeleted==false">
					<div class="col-5 px-1">
						<operator-job-add [job]="selected" [inline]="true" (jobChange)="load()"></operator-job-add>
					</div>
					<div class="col-7 border-right">
						<app-responsive-tab navigate="tab"
							[tabs]="[{name:'manage', title: 'مدیریت'},{name:'activity', title: 'فعالیت'},{name:'nps', title: 'بازخورد'},{name:'clearance', title: 'تسویه'},{name:'abuse', title: 'گزارش مشکل'},{name:'dev', title: 'dev'}]"
							(active)="selected._tab=$event">
						</app-responsive-tab>
						<div class="p-2">
							<div *ngIf="selected._tab?.name == 'manage'">
								<div class="d-flex flex-wrap mb-2 justify-content-between pb-2 border-bottom fs-sm">
									<label class="d-flex align-items-center">
										<span class="no-wrap ml-2">دسته بندی شغل:</span>
										<select class="fs-sm py-0" name="category" [(ngModel)]="selected.InternalCategory"
											(change)="save(selected)">
											<option *ngFor="let type of jobTypes" [ngValue]="type.Header">{{type.Header}}</option>
										</select>
									</label>
									<label class="d-flex align-items-center">
										<span class="no-wrap ml-2">تقویت پخش آگهی: </span>
										<input type="number" inputmode="numeric" class="fs-sm py-0" name="adminboost"
											placeholder="تقویت پخش آگهی" [(ngModel)]="selected.AdminBoost" (change)="save(selected)"
											style="width: 60px;">
									</label>
									<label class="d-flex align-items-center">
										<input type="checkbox" class="fs-sm py-0" name="isSponsored" [(ngModel)]="selected.IsSponsored"
											(change)="save(selected)">
										<span class="no-wrap ml-2">اسپانسر شده</span>
									</label>

								</div>
								<div class="kp-form-row pb-2 border-bottom">
									<label>
										<div>
											<h6>عنوان‌های شغلی</h6>
										</div>
										<ng-select class="w-100" name="job-titles" [multiple]="true" [addTag]="false" [items]="jobTitles"
											[(ngModel)]="selected.Metadata.JobTitles" placeholder="انتخاب جاب تایتل" bindLabel="Title">
										</ng-select>
									</label>
									<div class="text-left">
										<button class="btn btn-secondary btn-sm" (click)="save(selected)">ذخیره</button>
									</div>
									<div class="m-1 p-1 rounded-xl border x-light-gray-bg">
										<div class="text-left">
											<button class="btn btn-secondary btn-sm fs-sm"
												(click)="getJobTitleSuggestions(selected)">پیشنهادها (تستی)</button>
										</div>
										<div class="fs-sm p-1">
											<div class="btn btn-link btn-sm fs-sm ml-1"
												*ngFor="let suggestion of selected._jobTitleSuggestions"
												(click)="Utility.toggleInArray(selected.Metadata.JobTitles, suggestion.Title)"
												[class.btn-green]="Utility.isInArray(selected.Metadata.JobTitles, suggestion.Title)">
												{{suggestion.Title}}: {{suggestion._Score}}</div>
										</div>
										<div class="text-left" *ngIf="selected._jobTitleSuggestions">
											<button class="btn btn-secondary btn-sm fs-sm" (click)="save(selected)">ذخیره</button>
										</div>
									</div>
								</div>


								<div class="d-flex mb-2">
									<ng-container *ngSwitchCase="JobStatus.NotPaid">
										<button class="m-1 btn btn-green  fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Started, true)">
											تایید
										</button>
										<button class="m-1 btn btn-red  fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Archived)">آرشیو</button>
										<button class="m-1 btn btn-yellow  fs-sm p-1" type="button" *ngIf="!selected.IsIndexed"
											(click)="convertToRtwad(selected.Id)">تبدیل به آماده به کار</button>
									</ng-container>
									<ng-container *ngSwitchCase="JobStatus.Pending">
										<button *ngIf="selected.IsIndexed" class="m-1 btn btn-green  fs-sm p-1"
											(click)="setStatus(selected,JobStatus.Started, true)" type="button">تایید</button>
										<button *ngIf="!selected.IsIndexed" class="m-1 btn btn-green  fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Started, true)"> تایید
										</button>
										<button class="m-1 btn btn-red  fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Archived)">آرشیو</button>
											<button class="m-1 btn btn-yellow  fs-sm p-1" type="button" *ngIf="!selected.IsIndexed"
											(click)="convertToRtwad(selected.Id)">تبدیل به آماده به کار</button>
									</ng-container>
									<ng-container *ngSwitchCase="JobStatus.Rejected">
										<button class="m-1 btn btn-green fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Started, true)">تایید</button>
										<button class="m-1 btn btn-red fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Archived)">آرشیو</button>
											<button class="m-1 btn btn-yellow  fs-sm p-1" type="button" *ngIf="!selected.IsIndexed"
											(click)="convertToRtwad(selected.Id)">تبدیل به آماده به کار</button>
									</ng-container>
									<ng-container *ngSwitchCase="JobStatus.Started">
										<ng-container *ngIf="!selected.IsIndexed">
											<button id="ActionGroup" type="button" class="m-1 btn btn-green fs-sm p-1 dropdown-toggle"
												data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">عملیات</button>
											<div class="dropdown-menu" aria-labelledby="ActionGroup">
												<a class="dropdown-item" type="button"
													[routerLink]="['/admin','job-booster',selected.Code]">آلرت</a>
												<a class="dropdown-item" type="button"
													[routerLink]="['/admin','ads','image',selected.Code]">تصویر</a>
											</div>
										</ng-container>
										<button class="m-1 btn btn-yellow fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Paused)">توقف
											موقت</button>
									</ng-container>
									<ng-container *ngSwitchCase="JobStatus.Paused">
										<button class="m-1 btn btn-green fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Started, true)">شروع
											مجدد</button>
										<button class="m-1 btn btn-red fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Archived)">آرشیو</button>
									</ng-container>
									<ng-container *ngSwitchCase="JobStatus.Finished">
										<button class="m-1 btn btn-green fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Started, true)">شروع
											مجدد</button>
										<button class="m-1 btn btn-red fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Archived)">آرشیو</button>
									</ng-container>
									<ng-container *ngSwitchCase="JobStatus.Archived">
										<button class="m-1 btn btn-green fs-sm p-1" type="button" *ngIf="selected.IsPaid"
											(click)="setStatus(selected,JobStatus.Started, true)">تایید</button>
										<button class="m-1 btn btn-yellow fs-sm p-1" type="button" *ngIf="selected.IsPaid"
											(click)="setStatus(selected,JobStatus.Pending)">خروج
											از آرشیو</button>
										<button class="m-1 btn btn-yellow fs-sm p-1" type="button" *ngIf="!selected.IsPaid"
											(click)="setStatus(selected,JobStatus.NotPaid)">خروج
											از آرشیو</button>
									</ng-container>
									<ng-container *ngSwitchCase="JobStatus.Finished"></ng-container>
								</div>
								<div class=""
									*ngIf="selected.Status == JobStatus.Pending || selected.Status == JobStatus.NotPaid || selected.Status == JobStatus.Started || selected.Status == JobStatus.Rejected">
									<div class="">
										<textarea rows="2" class="h-100" placeholder="دلیل مرجوعی آگهی..."
											[(ngModel)]="selected.RejectionReason"></textarea>
									</div>
									<div class="text-left">
										<button class="m-1 btn btn-red fs-sm p-1" type="button"
											(click)="setStatus(selected,JobStatus.Rejected, true)">مرجوع</button>
									</div>

								</div>
								<div class="my-2 py-2 border-top border-2">
									<button class="m-1 btn btn-red fs-sm p-1" type="button" (confirm)="setIsDeleted(selected,true)">حذف
										کامل آگهی</button>
								</div>

							</div>
							<div *ngIf="selected._tab?.name == 'activity'">
								<button type="button" class="btn btn-secondary btn-sm fs-sm"
									*ngIf="selected.Status==JobStatus.NotPaid||selected.Status==JobStatus.Pending||selected.Status==JobStatus.Started"
									(click)="openActivities(selected)">برنامه ریزی فعالیت‌ها</button>
								<app-activity [inline]="true" [job]="selected.Id" [user]="selected.EmployerId"
									[limit]="1000"></app-activity>
							</div>
							<div *ngIf="selected._tab?.name == 'clearance'">
								<div>بودجه: {{selected.Budget | number}}</div>
								<div>پرداخت شده: {{selected.Paid | number}}</div>
								<div>مصرف شده: {{selected.UsedBudget | number}}</div>
								<div>فاکتور شده: {{selected.InvoicedBudget | number}}</div>
								<div>جمع تخفیف فاکتور شده: {{selected.InvoicedDiscount | number}}</div>
								<div>مبلغ فاکتور:
									<input type="number" #invoiceAmountInput
										[value]="Math.max(0, selected.Paid - selected.InvoicedBudget)" />
								</div>

								<div>
									<button class="btn btn-primary" (confirm)="clearance(selected, invoiceAmountInput.value)"
										message="از درست بودن مبلغ فاکتور مطمئن هستید؟">تسویه حساب</button>
								</div>
							</div>
							<div *ngIf="selected._tab?.name == 'nps'">
								<ng-container *ngIf="selected._nps">
									<h5 class="my-2">ثبت بازخورد کارفرما</h5>
									<div class="alert alert-warning" *ngIf="selected._nps.Score == 0">
										لطفا بازخورد کارفرما را نسبت به خدمات سایت کارپیشه ثبت کنید
									</div>
									<div>
										<label>چقدر احتمال دارد خدمات ما را به دیگران معرفی کنید؟ (یک عدد بین یک تا 10)</label>
										<select name="npsScore" [(ngModel)]="selected._nps.Score">
											<option value="0">ثبت نشده</option>
											<option value="1">1</option>
											<option value="2">2</option>
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
											<option value="6">6</option>
											<option value="7">7</option>
											<option value="8">8</option>
											<option value="9">9</option>
											<option value="10">10</option>
										</select>
										<label>مهمترین دلایل معرفی یا عدم معرفی ما چیست؟</label>
										<textarea name="npsComment" rows="5" [(ngModel)]="selected._nps.Comment"></textarea>
									</div>
									<div *ngIf="selected._nps.AnswerTime">
										زمان ثبت بازخورد: {{selected._nps.AnswerTime | pdate}}
									</div>
									<div class="text-left">
										<button class="btn btn-yellow" (click)="saveNps(selected._nps)">ذخیره</button>
									</div>
								</ng-container>

							</div>
							<div *ngIf="selected._tab?.name == 'abuse'">
								<div class="kp-card" *ngFor="let report of selected.AbuseReports">
									<div class="d-flex flex-wrap justify-content-between align-items-center ">
										<div class="light-gray-bg badge badge-pill">
											{{report.Time | pdate}}
										</div>
										<div class="light-gray-bg badge badge-pill" *ngIf="report['IP']">
											آی‌پی: {{report['IP']}}
										</div>
									</div>
									<div>
										<h6>دلیل</h6>
										<p>
											{{report.Reason}}
										</p>
									</div>
									<div>
										<div *ngIf="report.UserId != '00000000-0000-0000-0000-000000000000'">
											<div class="btn btn-secondary btn-sm fs-sm" (click)="getReportUser(report)">اطلاعات کاربر</div>
										</div>
										<div *ngIf="report._user">
											{{report._user.Name}} ({{report._user.Username}})
										</div>
									</div>


								</div>
							</div>
							<div *ngIf="selected._tab?.name == 'dev'">
								<div class="pb-2 mb-2 border-bottom">
									<h6>تگ‌های جاب تایتل <button class="btn btn-secondary btn-sm fs-sm"
											(click)="tagJobTitle(selected)">محاسبه مجدد</button></h6>
									<div class="d-flex flex-wrap ">
										<div class="badge dark-gray-bg f-yellow fs-normal m-1 no-wrap "
											*ngFor="let jt of selected._metaJobTitleTags">
											{{jt.Title}} - {{jt.Relevance}}
										</div>
									</div>
								</div>
								<pre class="p-1 text-left border overflow-auto fs-sm" dir="ltr" style="max-height: 200px;">
									{{selected | json}}
								</pre>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>



</section>

<ngx-smart-modal #activityModal identifier="activityModal">
	<ngx-spinner name="action" [fullScreen]="false" type="timer"></ngx-spinner>
	<div class="container-capped py-3" *ngIf="selected?.Tasks?._processed">
		<div class="row m-0">
			<label class="col-4 d-flex align-items-center">
				<input type="checkbox" name="task-email-add" [(ngModel)]="selected.Tasks.email.Enable" />
				<span>ایمیل</span>
			</label>
			<label class="col-8 d-flex align-items-center">
				<input class="w-initial ml-2 py-0" type="number" inputmode="numeric" name="task-email-count"
					[(ngModel)]="selected.Tasks.email.Count" />
				<span>تعداد</span>
			</label>

			<label class="col-4 d-flex align-items-center">
				<input type="checkbox" name="task-sms-add" [(ngModel)]="selected.Tasks.sms.Enable" />
				<span>پیامک</span>
			</label>
			<label class="col-8 d-flex align-items-center">
				<input class="w-initial ml-2 py-0" type="number" inputmode="numeric" name="task-sms-count"
					[(ngModel)]="selected.Tasks.sms.Count" />
				<span>تعداد</span>
			</label>


			<label class="col-4 d-flex align-items-center">
				<input type="checkbox" name="task-telegram_group-add" [(ngModel)]="selected.Tasks.telegram_group.Enable" />
				<span>پست گروهی تلگرام</span>
			</label>
			<div class="col-8 d-flex align-items-center">
				<label class="d-flex align-items-center">
					<input class="w-initial ml-2 py-0" type="number" inputmode="numeric" name="task-telegram_group-count"
						[(ngModel)]="selected.Tasks.telegram_group.Count" />
					<span>بار، </span>
				</label>
				<label class="d-flex align-items-center">
					هر
					<input class="w-initial ml-2 py-0" type="number" inputmode="numeric" name="task-telegram_group-RecurrenceDays"
						[(ngModel)]="selected.Tasks.telegram_group.RecurrenceDays" />
					<span>روز</span>
				</label>

			</div>

			<label class="col-4 d-flex align-items-center">
				<input type="checkbox" name="task-telegram_post-add" [(ngModel)]="selected.Tasks.telegram_post.Enable" />
				<span>پست اختصاصی تلگرام</span>
			</label>
			<div class="col-8 d-flex align-items-center">
				<label class="d-flex align-items-center">
					<input class="w-initial ml-2 py-0" type="number" inputmode="numeric" name="task-telegram_post-count"
						[(ngModel)]="selected.Tasks.telegram_post.Count" />
					<span>بار، </span>
				</label>
				<label class="d-flex align-items-center">
					هر
					<input class="w-initial ml-2 py-0" type="number" inputmode="numeric" name="task-telegram_post-RecurrenceDays"
						[(ngModel)]="selected.Tasks.telegram_post.RecurrenceDays" />
					<span>روز</span>
				</label>

			</div>

			<label class="col-4 d-flex align-items-center">
				<input type="checkbox" name="task-instagram_story-add" [(ngModel)]="selected.Tasks.instagram_story.Enable" />
				<span>استوری اینستاگرام</span>
			</label>
			<div class="col-8 d-flex align-items-center">
				<label class="d-flex align-items-center">
					<input class="w-initial ml-2 py-0" type="number" inputmode="numeric" name="task-instagram_story-count"
						[(ngModel)]="selected.Tasks.instagram_story.Count" />
					<span>بار، </span>
				</label>
				<label class="d-flex align-items-center">
					هر
					<input class="w-initial ml-2 py-0" type="number" inputmode="numeric"
						name="task-instagram_story-RecurrenceDays" [(ngModel)]="selected.Tasks.instagram_story.RecurrenceDays" />
					<span>روز</span>
				</label>

			</div>

			<label class="col-12">
				<input type="checkbox" name="task-instagram_post-add" [(ngModel)]="selected.Tasks.instagram_post.Enable" />
				<span>پست اینستاگرام</span>
			</label>

			<label class="col-12 d-flex align-items-center">
				<input type="checkbox" name="task-twitter-add" [(ngModel)]="selected.Tasks.twitter.Enable" />
				<span>توییتر</span>
			</label>
			<label class="col-12 d-flex align-items-center">
				<input type="checkbox" name="task-linkedin-add" [(ngModel)]="selected.Tasks.linkedin.Enable" />
				<span>لینکداین</span>
			</label>
			<label class="col-12 d-flex align-items-center">
				<input type="checkbox" name="task-push-add" [(ngModel)]="selected.Tasks.push.Enable" />
				<span>نوتیفیکیشن</span>
			</label>

			<label class="col-12">
				<input type="checkbox" name="task-reportage-add" [(ngModel)]="selected.Tasks.reportage.Enable" />
				<span>رپورتاژ آگهی</span>
			</label>

		</div>
		<div class="text-left">
			<button class="btn btn-yellow" type="button" (click)="addActivities()">ایجاد فعالیت ها</button>
		</div>
	</div>
</ngx-smart-modal>
<ng-template #jobStatusBadge let-job="job">
	<div class="d-flex">

		<div class="fs-normal" [ngSwitch]="job.Status">
			<div class="orange-bg f-white badge badge-pill" *ngSwitchCase="JobStatus.NotPaid">
				در انتظار پرداخت
			</div>
			<div class="yellow-bg badge badge-pill" *ngSwitchCase="JobStatus.Pending">
				در انتظار تایید
			</div>
			<div class="red-bg p-1 f-white  badge badge-pill" *ngSwitchCase="JobStatus.Rejected">
				مرجوع شده
			</div>
			<ng-container *ngSwitchCase="JobStatus.Started">
				<div class="green-bg f-white badge badge-pill" *ngIf="!job.IsExpired"> تایید شده </div>
				<div class="light-gray-bg badge badge-pill" *ngIf="job.IsExpired">منقضی شده</div>
			</ng-container>
			<div class="orange-bg f-white badge badge-pill" *ngSwitchCase="JobStatus.Paused">
				موقتا متوقف شده <span class="f-red border border-red p-1" *ngIf="job.AbuseReports?.length"
					[title]="job.AbuseReports|json">گزارش تخلف</span>
			</div>
			<div class="dark-gray-bg f-white badge badge-pill" *ngSwitchCase="JobStatus.Archived">
				آرشیو شده
			</div>
			<div class="gray-bg f-white badge badge-pill" *ngSwitchCase="JobStatus.Finished">
				خاتمه یافته
			</div>
		</div>
		<div class="red-bg p-1 f-white  badge badge-pill mr-2" *ngIf="job.AbuseReports?.length"
			[title]="job.AbuseReports|json">گزارش
			تخلف</div>
	</div>

</ng-template>
<ng-template #jobKind let-job="job">
	<div>
		<div class="badge badge-pill light-gray-bg" [ngSwitch]="job.Kind">
			<ng-container *ngSwitchCase="Kind.Resume">رزومه</ng-container>
			<ng-container *ngSwitchCase="Kind.Basic">ماهر</ng-container>
			<ng-container *ngSwitchCase="Kind.Call">تماس</ng-container>
			<ng-container *ngSwitchCase="Kind.NotAppliable">وب سایت</ng-container>
			<ng-container *ngSwitchDefault>نامشخص</ng-container>
		</div>
	</div>
</ng-template>
<ngx-smart-modal #changeOwnerModal identifier="changeOwnerModal">
	<ngx-spinner name="change-username" [fullScreen]="false" type="timer"></ngx-spinner>
	<form class="container-sm py-5" *ngIf="selected">
		<div>
			<label>
				<h6>شماره مقصد</h6>
				<input type="text" #newUsernameInput name="new-username" />
			</label>
		</div>
		<div>
			<button class="btn btn-link" (click)="changeOwnerModal.close()">انصراف</button>
			<button class="btn btn-primary" (click)="changeOwner(newUsernameInput.value)">تایید</button>
		</div>

	</form>
</ngx-smart-modal>
